
import { RouterName } from "@/models/common";
import { useStore } from "vuex";
import { ref, computed, defineComponent, onMounted, reactive, Ref } from "vue";
import { useI18n } from "vue-i18n";
import { IRequestSummary, RequestKindTypes } from "@/models/request";
import $API from "@/services";
import { CommonMutationTypes } from "@/store/modules/common/mutations";
import { IDoctorListItem, PossibleTypes } from "@/models/doctor";
import { isActivePath } from "@/router";
import { IProfilePicture } from "@/models/account";


export default defineComponent({
  name: "Mypage Layout",
  setup() {
    const { t } = useI18n({ useScope: "global" });

    const isPaid = ref(process.env.VUE_APP_IS_PAID || false); // computed(()=> process.env.VUE_APP_IS_PAID || false)

    const path = reactive({
      Profile: { name: RouterName.PROFILE },
      Password: { name: RouterName.PASSWORD },
      OrderList: { name: RouterName.ORDER_LIST },
      MyDoctor: { name: RouterName.MY_DOCTOR },
    });
    const store = useStore();
    const accountInfo = reactive({
      name: store.getters.getAccountInfo?.Name,
      email: store.getters.getAccountInfo?.UserName,
    });

    const summary = reactive({
      OnlineCare: null as IRequestSummary | null,
      SecondOpinion: null as IRequestSummary | null,
      Doctors: null as Array<IDoctorListItem> | null,
      isLoading: false,
    });

    const isActive = (s: string) => {
      return isActivePath(s);
    };

    const getOnlineCareSummary = async () => {
      const summaryData = await $API.RequestService.getRequsetSummary(
          RequestKindTypes.OnlineCare
        );
       
      if (summaryData === undefined || Array.isArray(summaryData)) return;

      summary.OnlineCare = summaryData;
    };

    const getSecondOpinionSummary = async () => {
      const summaryData = await $API.RequestService.getRequsetSummary(
          RequestKindTypes.SecondOpinion
        );
 
      if (summaryData === undefined || Array.isArray(summaryData)) return;

      summary.SecondOpinion = summaryData;
    };

    const getDoctorList = async () => {
      try {
        const doctorList = await $API.DoctorService.getDoctorList(PossibleTypes.ALL);
        summary.Doctors = doctorList;
        return doctorList;
      } catch(ex) {
        console.warn(ex);
        return  [];
      }
    };

    
    const getMyProfilePicture = async () => {
      try {
        userProfilePicture.value = await $API.AccountsService.getMyPicture();
      } catch(ex) {
        console.error(ex, 'getMyProfilePicture.ex');
      }
    };


    const DoctorCount = computed(() => {
      if (summary.Doctors)
        return summary.Doctors?.filter((x) => x.MyDoctor).length;
      return "-";
    });

    const ServiceCount = computed(() => {
      if (summary.OnlineCare && summary.SecondOpinion) {
        const p = {
          onlineCare: {
            response:
              summary.OnlineCare.Canceled.valueOf() +
              summary.OnlineCare.Completed.valueOf(),
            request:
              summary.OnlineCare.Requested.valueOf() +
              summary.OnlineCare.Scheduled.valueOf(),
          },
          secondOpinion: {
            response:
              summary.SecondOpinion.Canceled.valueOf() +
              summary.SecondOpinion.Completed.valueOf(),

            request:
              summary.SecondOpinion.Requested.valueOf() +
              summary.SecondOpinion.Scheduled.valueOf(),
          },
        };
        return p;
      }

      return {
      
        onlineCare: {
          request: "-",
          response: "-",
        },
        secondOpinion: {
          request: "-",
          response: "-",
        },
      };
    });

    const userProfilePicture:Ref<IProfilePicture> = ref({} as IProfilePicture);

    const isValidUserProfile  = computed(()=>{
      return (userProfilePicture.value ?.Key ?? '').length > 0;
    })

    const userPicture = computed(()=>{
      const pic = userProfilePicture.value?.Picture??'';
      if(pic.length <= 0) return '';
      return 'data:image/png;base64,' + userProfilePicture.value?.Picture;
    });


    onMounted(async () => {
      try {
        console.log(isPaid.value, '<=isPaid')
        store.commit(CommonMutationTypes.SET_IS_LODING, true);

        await getOnlineCareSummary();
        await getSecondOpinionSummary();
        await getDoctorList();

        await getMyProfilePicture();

        summary.isLoading = true;
      } catch (e) {
        console.error(e);
      } finally {
        store.commit(CommonMutationTypes.SET_IS_LODING, false);
      }
    });

    return {
      t,
      path,
      accountInfo,
      ServiceCount,
      summary,
      DoctorCount,
      isActive,
      isPaid,
      isValidUserProfile,
      userPicture
    };
  },
});
